import {Controller} from "stimulus"

export default class extends Controller {
    static get targets() {
        return ["wrapper"]
    }

    connect() {
        this.wrapper = $(this.wrapperTarget)
        this.selectWrapper = this.wrapper.find('#points_tables_statistics_recommendation_campaign')
        this.structurePointsTables = this.wrapper.find('.structure-points-table-component')
        this.selectWrapper.on('change', this._reload_points_tables)
    }

    disconnect() {
        this.selectWrapper.unbind('change');
    }

    _reload_points_tables = () => {
        this._update_week_url('change-week-points-table-previous')
        this._update_week_url('change-week-points-table-next')
        this.structurePointsTables.attr('data-campaign', this.selectWrapper.val())
        this.structurePointsTables.data('campaign', this.selectWrapper.val())
        this.structurePointsTables.trigger('reloadPointsTable')
    }

    _update_week_url = (id) => {
        const link = document.getElementById(id)
        if(link != null)
        {
            const url = new URL(link.href);
            url.searchParams.set('campaign', this.selectWrapper.val())
            link.href = url.toString();
        }
    }
}